<template>
    <section id="userIndex">
        <CategoryForm
            :dialogProp="formDialog"
            @dialog:close="closeDialog"
            :dataToForm="dataToForm"
            :mode="formMode"
        />
        <DeleteCategory
            :dialogProp="deleteDialog"
            @dialog:close="closeDialog"
            :item="itemToDelete"
        />
        <v-container fluid>
            <v-row class="justify-between align-center">
                <v-col cols="12" md="auto">
                    <v-btn
                        class="accent shadow-4 px-8"
                        large
                        rounded
                        @click.stop="openRegisterForm()"
                        >Añadir Categorias</v-btn
                    >
                </v-col>

                <v-col cols="12" md="auto" class="ml-auto">
                    <v-text-field
                        filled
                        rounded
                        dense
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-container>

        <v-card class="shadow-1">
            <v-data-table
                :headers="headers"
                :items="Categories"
                :search="search"
                :loading="isLoading"
                :options.sync="options"
                :server-items-length="totalItems"
                :footer-props="{
                    'items-per-page-options': [15, 30, 50, 100]
                }"
            >
                <template v-slot:[`item.title`]="{ item }">
                    <v-list
                        two-line
                        max-width="350px"
                        class="transparent my-0 py-0"
                    >
                        <v-list-item class="px-0">
                            <v-list-item-content class="d-block d-md-none mr-2">
                                <v-list-item-title
                                    class="primary--text text--darken-1 font-weight-medium"
                                    v-html="item.title"
                                ></v-list-item-title>
                                <v-list-item-subtitle
                                    v-html="item.description"
                                ></v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-content class="d-none d-md-block ml-3">
                                <v-list-item-title
                                    class="text--darken-1 font-weight-medium"
                                    v-html="item.title"
                                ></v-list-item-title>
                                <v-list-item-subtitle
                                    v-html="item.description"
                                ></v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </template>

                <template v-slot:[`item.questions`]="{ item }">
                    <v-list-item-content class="d-md-block ml-3">
                        <v-btn
                            class="accent shadow-4 px-8"
                            rounded
                            @click.stop="routeToQuestions(item.id)"
                            >Ver Preguntas</v-btn
                        >
                    </v-list-item-content>
                </template>

                <template v-slot:[`item.action`]="{ item }">
                    <v-hover v-slot:default="{ hover }">
                        <v-btn
                            text
                            icon
                            :color="hover ? 'accent' : 'blue-grey'"
                            @click.stop="editCategory(item)"
                        >
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </v-hover>

                    <v-hover v-slot:default="{ hover }">
                        <v-btn
                            text
                            icon
                            :color="hover ? 'error' : 'blue-grey'"
                            @click.stop="deleteCategory(item)"
                        >
                            <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                    </v-hover>
                </template>
            </v-data-table>
        </v-card>

        <router-view></router-view>
    </section>
</template>

<script>
import CategoryForm from "@/components/Categories/CategoryForm";
import DeleteCategory from "@/components/Categories/DeleteCategory";

export default {
    components: {
        DeleteCategory,
        CategoryForm
    },
    data() {
        return {
            isLoading: false,
            // For pagination
            totalItems: 0,
            options: {
                page: 1,
                itemsPerPage: 15
            },
            // End for pagination
            headers: [
                {
                    text: "Nombre",
                    align: "left",
                    sortable: true,
                    value: "title",
                    class: "primary--text",
                    width: "30%"
                },
                {
                    text: "Preguntas Asociadas",
                    align: "left",
                    sortable: false,
                    value: "questions",
                    class: "primary--text",
                    width: "10%"
                },
                {
                    text: "Acciones",
                    value: "action",
                    class: "primary--text",
                    width: "15%",
                    align: "center",
                    sortable: false
                }
            ],
            search: "",
            data: [],
            UserInfo: [],
            // Form
            formDialog: false,
            formMode: "register",
            dataToForm: null,

            //Delete Dialog
            deleteDialog: false,
            itemToDelete: null,

            dialog: false,
            dialogTableVisible: false,
            clientInfo: "",
            updateActive: false,
            errorData: "",
            activeAlert: "",
            colorAlert: ""
        };
    },
    created() {
        this.GetCategories();
    },

    watch: {
        options: {
            handler() {
                this.GetCategories();
            },
            deep: true
        }
    },

    computed: {
        Categories() {
            return this.$store.getters["categories/GET_ALL_CATEGORIES"];
        }
    },

    methods: {
        openRegisterForm() {
            this.formDialog = true;
            this.formMode = "register";
        },
        closeDialog() {
            this.formDialog = false;
            this.deleteDialog = false;
            this.itemToDelete = false;
            this.dataToForm = null;
        },
        editCategory(item) {
            this.formDialog = true;
            this.formMode = "edit";
            this.dataToForm = item;
        },
        deleteCategory(item) {
            this.itemToDelete = item;
            this.deleteDialog = true;
        },
        // Store
        async GetCategories() {
            this.isLoading = true;

            const { sortBy, sortDesc, page, itemsPerPage } = this.options;

            const payload = {
                page,
                itemsPerPage
            };

            try {
                const response = await this.$store.dispatch(
                    "categories/SHOW_CATEGORIES",
                    payload
                );
                this.totalItems = response.total;
            } catch (error) {
                console.log(error);
            }
            this.isLoading = false;
        },

        routeToQuestions(id) {
            this.$router.push(`/categories/${id}/questions`);
        }
    }
};
</script>
